import { useState, useEffect } from "react";

/**
 * windowサイズでPCかどうかを判定する
 */
export const useIsPC = () => {
  const [isPC, setIsPC] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width >= 768) {
        setIsPC(true);
      } else {
        setIsPC(false);
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return isPC;
};

export default useIsPC;
